export default "__VITE_ASSET__BJ_Gy1en__"